import { Platform } from '@angular/cdk/platform';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { afterNextRender, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NzImageModule, NzImageService } from 'ng-zorro-antd/image';
import { Swiper } from 'swiper/types';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';
import { FileApiService } from '../../../services/apis/file-api.service';

@Component({
  selector: 'app-product-images-carousel',
  imports: [
    NgOptimizedImage,
    FileurlPipe,
    MatIconModule,
    NzImageModule,
    NgClass
  ],
  templateUrl: './product-images-carousel.html',
  styleUrl: './product-images-carousel.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductImagesCarousel implements OnChanges {
  @Input({ required: true }) images: string[] = [];
  @Input() altText: string = 'Product image';
  @Input() currentImage: string = '';

  constructor(
    private imageService: NzImageService,
    private fileApi: FileApiService,
    private platform: Platform,
  ) {
    if (this.platform.isBrowser) {
      afterNextRender(() => {
        if (this.swiperRef && this.swiperRef.nativeElement) {
          // 此时 DOM 已经挂载，且确认为浏览器环境
          this.swiper = this.swiperRef.nativeElement.swiper;
          console.log('在浏览器中成功获取 Swiper 实例:', this.swiper);
        }
      });
    }
  }


  @ViewChild('swiper') swiperRef?: ElementRef;
  swiper?: Swiper;


  ngOnChanges(changes: SimpleChanges): void {
    if (this.currentImage && this.swiper) {
      const index = this.images.indexOf(this.currentImage);
      if (index >= 0) {
        this.swiper?.slideTo(index, 500);
      }
    }
  }




  choose(index: number) {
    this.currentImage = this.images[index];
  }


  preview() {
    const index = this.images.indexOf(this.currentImage);
    this.imageService.preview(this.images.map((image) => {
      return {
        src: this.fileApi.fileurl(image),
      };
    })).switchTo(index);
  }

}
